export const NEW_QUEUE = 'new_queue';
export const NEW_SEARCH = 'new_search';
